import { Button, Form, Image, Modal } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { NUMBERS } from '../../../resources/number-constants';
import ButtonLoader from '../../../pages/ButtonLoader';
import { checkWhite } from '../../../assets/images/images';
import CertificateEdit from './CertificateEdit';
import { wrapAllContentInList } from '../../../utility/helpers';
import IndustryEdit from './IndustryEdit';
import DistanceEdit from './DistanceEdit';

const listTypeFieldKeys: string[] = [
  "alternative_job_title",
  "responsibilities",
  "value_plus_goals",
  "skills",
  "experience",
  "education",
  "language",
  "work_on",
  "work_approach",
  "industries",
  "prior_company_name",
  "citizenship_work_authorization",
  "security_clearance",
  "location",
  "timezone",
  "distance"
];

const JDEditField = ({
    aboutShow,
    setAboutShow,
    modalHeading,
    actionKey,
    modalData,
    setModalData,
    titleValue,
    setTitleValue,
    showLoader,
    handleSave
}: any) => {
    const modules = {
        toolbar: [
            [{ 'header': [NUMBERS.ONE, NUMBERS.TWO, false] }],
            ['bold', 'italic', 'underline','strike'],
            [{'list': 'ordered'}, {'list': 'bullet'}]
        ],
    };
    
    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet'
    ];

    const handleInputChange = (event: any) => {
        setTitleValue(event.target.value);
    };

    const handleChanges = (value: any) => {
      if (listTypeFieldKeys.indexOf(actionKey) !== -1 && typeof value === 'string') {
        const cleanedValue = wrapAllContentInList(value);
        setModalData(cleanedValue);
      } else  {
        const cleanedValue = value.replace(/<li>\s*(<br>)?\s*<\/li>/g, "");
        setModalData(cleanedValue);
      }
    };

    return (
      <>
        <Modal show={aboutShow} centered className="about-modal">
          <Modal.Header>{modalHeading[actionKey]}</Modal.Header>
          <Modal.Body className={showLoader ? "pe-none" : ""}>
            {actionKey !== "title" &&
              actionKey !== "hybrid_schedule" &&
              actionKey !== "certificate" &&
              actionKey !== "industries" &&
              actionKey !== "distance" && (
                <ReactQuill
                  value={modalData}
                  onChange={handleChanges}
                  modules={modules}
                  formats={formats}
                />
              )}

            {actionKey === "certificate" && (
              <CertificateEdit value={modalData} setModalData={setModalData} />
            )}

            {actionKey === "distance" && (
              <DistanceEdit value={modalData} setModalData={setModalData} />
            )}

            {actionKey === "industries" && (
              <IndustryEdit value={modalData} setModalData={setModalData} />
            )}

            {actionKey === "title" && (
              <div className="form-wrap">
                <Form
                  className="full-width-form"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                >
                  <div className="tier-name">
                    <Form.Group className="form-group">
                      <Form.Control
                        type="text"
                        name="title"
                        value={titleValue}
                        maxLength={NUMBERS.HUNDRED}
                        onChange={handleInputChange}
                        isInvalid={titleValue?.length >= NUMBERS.HUNDRED}
                      />
                      <div className="job-title-error-wrapper">
                        {titleValue?.length >= NUMBERS.HUNDRED && (
                          <div className="title-invalid-feedback">
                            Oops! You've hit the maximum allowed characters.
                          </div>
                        )}
                        <div className="char-count">
                          {titleValue?.length}/{NUMBERS.HUNDRED}
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                </Form>
              </div>
            )}

            {actionKey === "hybrid_schedule" && (
              <div className="form-wrap">
                <Form
                  className="full-width-form"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                >
                  <div className="tier-name">
                    <Form.Group className="form-group">
                      <Form.Control
                        type="text"
                        name="hybrid"
                        value={titleValue}
                        placeholder="e.g., 2 days remote, 3 days onsite – flexible on timings"
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  </div>
                </Form>
              </div>
            )}

            <div className="footer-btn about-action">
              <Button
                variant="cancel"
                className="btn-cancel-filled"
                onClick={() => setAboutShow(false)}
              >
                Close
              </Button>
              <Button
                variant="primary"
                onClick={handleSave}
                disabled={showLoader}
              >
                <Image
                  src={checkWhite}
                  height={20}
                  width={20}
                  alt="Right"
                  className="prefix-icon"
                />
                {showLoader ? <ButtonLoader /> : "Save Edits"}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
}

export default JDEditField;